export enum ListCardGroupVariant {
  SINGLE = 'single',
  GROUP = 'group',
}

export interface IListCardGroup {
  header?: string | React.ReactElement;
  items: any[];
  renderItem: (renderItem: { item: any; index: number; rowIndex: number }) => any;
  ItemCustomizationComponent?: JSX.Element | null;
  selectedRow?: number | null;
  numColumns?: number;
  variant?: ListCardGroupVariant;
  isFullContainer?: boolean;
}

export interface IRenderItemRow {
  item: any;
  index: number;
}
